import { ScrollDirection } from '../../types/scroll-direction';
import { Animator, easeInOutSine } from '../animator';
export const scrollElementToPositionWithAnimation = (element, scrollPosition) => {
    const handleScrollAnimationFrame = (frame) => {
        const { progress, isFinalFrame, startState, endState } = frame;
        if (isFinalFrame) {
            element.scrollLeft = endState;
            return;
        }
        element.scrollLeft = easeInOutSine(progress, startState, endState);
    };
    const animator = new Animator(element.scrollLeft, scrollPosition, 300, handleScrollAnimationFrame);
    animator.start();
};
export const scrollElementBy = (element, delta) => {
    const scrollPosition = element.scrollLeft + delta;
    scrollElementToPositionWithAnimation(element, scrollPosition);
};
export const scrollElementClientWidth = (element, direction) => {
    const delta = direction === ScrollDirection.Left ? -element.clientWidth : element.clientWidth;
    scrollElementBy(element, delta);
};
export const scrollElementIntoView = (element, view, boundary) => {
    var _a, _b;
    const leftmostBoundary = (_a = boundary.left) !== null && _a !== void 0 ? _a : view.getBoundingClientRect().left;
    const rightmostBoundary = (_b = boundary.right) !== null && _b !== void 0 ? _b : view.getBoundingClientRect().right;
    const elementRect = element.getBoundingClientRect();
    const leftOfElementIsInBoundary = elementRect.left > leftmostBoundary;
    const rightOfElementIsInBoundary = elementRect.right < rightmostBoundary;
    const elementIsInView = leftOfElementIsInBoundary && rightOfElementIsInBoundary;
    const elementIsLargerThanView = !leftOfElementIsInBoundary && !rightOfElementIsInBoundary;
    if (elementIsInView || elementIsLargerThanView)
        return;
    if (!leftOfElementIsInBoundary)
        scrollElementBy(view, elementRect.left - leftmostBoundary);
    else if (!rightOfElementIsInBoundary)
        scrollElementBy(view, elementRect.right - rightmostBoundary);
};
/**
 * Scrolls the browser so the element starts at the top of the browser window.
 * @param id The id of the element to scroll to.
 */
export const scrollToElementById = (id) => {
    const element = document.getElementById(id);
    element === null || element === void 0 ? void 0 : element.scrollIntoView();
};
